import { fetchApi } from './api';
import type { SupplierPmConfigData, SupplierPmEmployeesData, SupplierPmAssignment } from '../types/supplierPmConfig';

export const supplierPmConfigApi = {
    getSuppliers: () =>
        fetchApi<SupplierPmConfigData>('/supplier-pm-config/suppliers'),

    getEmployees: () =>
        fetchApi<SupplierPmEmployeesData>('/supplier-pm-config/employees'),

    assign: (companyCode: string, supplierDimID: string, staffID: string, isPrimary = false) =>
        fetchApi<SupplierPmAssignment>(
            '/supplier-pm-config/assignments',
            {
                method: 'POST',
                body: JSON.stringify({ companyCode, supplierDimID, staffID, isPrimary }),
            }
        ),

    unassign: (assignmentId: number) =>
        fetchApi<{ assignmentId: number }>(
            `/supplier-pm-config/assignments/${assignmentId}`,
            { method: 'DELETE' }
        ),
};
